import React from "react";
import logoWhite from "../../assets/images/minutezilla-logo-white.png";

export const BlackLogo = () => {
  return (
    <img
      src={logoWhite}
      alt="Minutezilla"
      style={{ height: "36px", width: "auto" }}
    />
  );
};
